import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

// 브라우저의 기본 스크롤 동작 허용
if ("scrollRestoration" in window.history) {
  window.history.scrollRestoration = "auto";
}

const root = createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
